import styled from 'styled-components';
import { media } from '@/styles/breakpoints';

export const PageWrapper = styled.div`
    background: ${(props) => props.theme['Surface/page']};
    margin-bottom: 24px;
`;

export const PageTitle = styled.div`
    color: ${(props) => props.theme['Content/primary']};
    font-family: 'Poppins', serif;
    font-size: 34px;
    font-style: normal;
    font-weight: 600;
    line-height: 44px;
`;

export const LeftSideHeader = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
`;

export const PageContent = styled.div`
    border: 1px solid ${(props) => props.theme['Borders/quiet']};
    overflow-x: hidden;
`;

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 12px 0;
`;

/**
 * Side gutters of the page containers, per breakpoint. Exported so an element that has to
 * break out of them — a sticky bar whose background must reach the screen edges, say — can
 * cancel them exactly instead of repeating the numbers and drifting out of step.
 */
export const PAGE_GUTTER = {
    desktop: 40,
    tablet: 24,
    phone: 16,
};

export const ContainerPageMiddle = styled.div`
    padding: 0 ${PAGE_GUTTER.desktop}px;
    min-width: 1100px;
    max-width: 1600px;
    margin: 0 auto;
`;

/**
 * Fluid variant of ContainerPageMiddle for pages that have a responsive layout of
 * their own. Same desktop gutters and max width, but no desktop-only floor.
 */
export const ContainerPageFluid = styled.div`
    padding: 0 ${PAGE_GUTTER.desktop}px;
    max-width: 1600px;
    margin: 0 auto;

    ${media.tablet} {
        padding: 0 ${PAGE_GUTTER.tablet}px;
    }

    ${media.phone} {
        padding: 0 ${PAGE_GUTTER.phone}px;
    }
`;

export const WrapperForm = styled.div`
    padding: 24px 32px;
    background: ${(props) => props.theme['Surface/page']}
        /* TODO: check color. Alternatives: ["Surface/page","Surface/primary","Content/inverse","Content/overlay"] */;
`;
